const goShopCate_a = [
  {
    link: "gift sets",
    name: "gift_sets",
    image: "https://dqq88qh287mi6.cloudfront.net/assets/images/1786640479986-0-Gift-sets.jpg",
  },

  {
    link: "mens grooming",
    name: "mens_grooming",
    image: "https://dqq88qh287mi6.cloudfront.net/assets/images/1786640479986-1-mens-grooming.jpg",
  },
  {
    link: "board games",
    name: "Board Games",
    image: "https://dqq88qh287mi6.cloudfront.net/assets/images/1786640479986-2-Board-Games-x.png",
  },
  {
    link: "stationary",
    name: "stationary",
    image: "https://dqq88qh287mi6.cloudfront.net/assets/images/1786640479986-3-Stationary.png",
  },
  {
    link: "sports",
    name: "sports",
    image: "https://dqq88qh287mi6.cloudfront.net/assets/images/1786640479986-4-Sports-1.png",
  },

  {
    link: "phone accessories",
    name: "phone_accessories",
    image: "https://dqq88qh287mi6.cloudfront.net/assets/images/1786640479986-5-Phone-Accessories-1.png",
  },
  {
    link: "shoes",
    name: "shoes",
    image: "https://dqq88qh287mi6.cloudfront.net/assets/images/1786640479986-6-Shoes-1.png",
  },
];

const goShopCM = [
  {
    link: "/search/makeup",
    image: "https://dqq88qh287mi6.cloudfront.net/assets/images/1786641177831-0-Makeup-1.jpg",
  },
];

const goShopCate_b = [
  {
    link: "andriod phone",
    name: "andriod_phone",
    image: "https://dqq88qh287mi6.cloudfront.net/assets/images/1786640479986-7-Andriod-phone.jpg",
  },
  {
    link: "gaming accessories",
    name: "gaming_accessories",
    image: "https://dqq88qh287mi6.cloudfront.net/assets/images/1786640479986-8-gaming-accessories.jpg",
  },
  {
    link: "gaming console",
    name: "gaming_console",
    image: "https://dqq88qh287mi6.cloudfront.net/assets/images/1786640479986-9-gaming-console.jpg",
  },
  {
    link: "gaming sets",
    name: "gaming_sets",
    image: "https://dqq88qh287mi6.cloudfront.net/assets/images/1786640505350-0-gaming-set-ups.jpg",
  },
  {
    link: "headphones",
    name: "headphones",
    image: "https://dqq88qh287mi6.cloudfront.net/assets/images/1786640505350-1-headphones.jpg",
  },
  {
    link: "laptops",
    name: "laptops",
    image: "https://dqq88qh287mi6.cloudfront.net/assets/images/1786640505350-2-laptop.jpg",
  },
];

const goShopCate_c = [
  {
    link: "watches",
    name: "watches",
    image: "https://dqq88qh287mi6.cloudfront.net/assets/images/1786640505350-3-watches-1.png",
  },
  {
    link: "speakers",
    name: "speakers",
    image: "https://dqq88qh287mi6.cloudfront.net/assets/images/1786640505350-4-Speakers-2.png",
  },
  {
    link: "music instruments",
    name: "music_instruments",
    image: "https://dqq88qh287mi6.cloudfront.net/assets/images/1786640505350-5-Music-Instruments.png",
  },
  {
    link: "toys",
    name: "toys",
    image: "https://dqq88qh287mi6.cloudfront.net/assets/images/1786641402145-0-Toys2.jpg",
  },
  {
    link: "gaming console",
    name: "gaming_console",
    image: "https://dqq88qh287mi6.cloudfront.net/assets/images/1786640505350-7-Gaming-Consoles-01.png",
  },
];

const goShopFashion = [
  {
    link: "jacket",
    name: "jackets",
    image: "https://dqq88qh287mi6.cloudfront.net/assets/images/1786640505350-8-Jackets.jpg",
  },
  {
    link: "boot",
    name: "boots",
    image: "https://dqq88qh287mi6.cloudfront.net/assets/images/1786640505350-9-Boots.jpg",
  },
  {
    link: "hoodies and sweatshirts",
    name: "hoodies_and_sweat_shirts",
    image: "https://dqq88qh287mi6.cloudfront.net/assets/images/1786640523589-0-Hoodies.jpg",
  },
  {
    link: "jeans",
    name: "jeans",
    image: "https://dqq88qh287mi6.cloudfront.net/assets/images/1786640523589-1-Jeans.jpg",
  },
  {
    link: "t-shirt",
    name: "tshirts",
    image: "https://dqq88qh287mi6.cloudfront.net/assets/images/1786640523589-2-T-SHirts.jpg",
  },
  {
    link: "women dress",
    name: "women_dress",
    image: "https://dqq88qh287mi6.cloudfront.net/assets/images/1786640523589-3-Ladies-Dress.jpg",
  },
];

const HomeData = {
  category_a: goShopCate_a,
  category_b: goShopCate_b,
  category_c: goShopCate_c,
  fashion: goShopFashion,
  carousel: goShopCM,
};

export default HomeData;
